import React from "react";
import { Box, Typography, Grid, Card, CardContent, Button, Divider } from "@mui/material";
import { Bar, Pie } from "react-chartjs-2";

const SocialMediaDashboard = () => {
  // Sample data for charts
  const engagementData = {
    labels: ["Facebook", "Instagram", "Twitter", "LinkedIn"],
    datasets: [
      {
        label: "Engagements",
        data: [120, 200, 150, 80],
        backgroundColor: ["#3b5998", "#E1306C", "#1DA1F2", "#0077B5"],
      },
    ],
  };

  const taskData = [
    { id: 1, title: "Schedule posts for the week", status: "In Progress" },
    { id: 2, title: "Analyze last week's campaign performance", status: "Pending" },
    { id: 3, title: "Engage with followers on Instagram", status: "Completed" },
  ];

  const postPerformanceData = {
    labels: ["Post 1", "Post 2", "Post 3", "Post 4"],
    datasets: [
      {
        label: "Likes",
        data: [50, 80, 30, 100],
        backgroundColor: "#4caf50",
      },
      {
        label: "Shares",
        data: [20, 40, 10, 60],
        backgroundColor: "#2196f3",
      },
    ],
  };

  return (
    <Box
      sx={{
        padding: 4,
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      <Typography variant="h4" component="h1" gutterBottom align="center">
        Social Media Executive Dashboard
      </Typography>
      <Typography variant="body1" color="textSecondary" gutterBottom align="center">
        Welcome to your dashboard! Track your social media performance and manage your tasks here.
      </Typography>

      <Divider sx={{ marginY: 3 }} />

      <Grid container spacing={4}>
        {/* Engagement Metrics */}
        <Grid item xs={12} md={6}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h6" gutterBottom align="center">
                Engagement Metrics
              </Typography>
              <Pie data={engagementData} />
            </CardContent>
          </Card>
        </Grid>

        {/* Post Performance */}
        <Grid item xs={12} md={6}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h6" gutterBottom align="center">
                Post Performance
              </Typography>
              <Bar data={postPerformanceData} options={{ responsive: true }} />
            </CardContent>
          </Card>
        </Grid>

        {/* Task List */}
        <Grid item xs={12}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h6" gutterBottom align="center">
                Task List
              </Typography>
              <Grid container spacing={2}>
                {taskData.map((task) => (
                  <Grid item xs={12} sm={6} md={4} key={task.id}>
                    <Card elevation={2} sx={{ height: "100%" }}>
                      <CardContent sx={{ textAlign: "center" }}>
                        <Typography variant="body1" gutterBottom>
                          {task.title}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Status: {task.status}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* Action Button */}
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{
              padding: 1.5,
              fontWeight: "bold",
              fontSize: "16px",
            }}
            onClick={() => alert("Feature coming soon!")}
          >
            View Detailed Reports
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SocialMediaDashboard;